module.exports = __webpack_public_path__ + "media/images/emblems/Hagenbuch-blazon-77f681001208dace2d0c2b2fc5e3912a.svg";